module.exports = __webpack_public_path__ + "static/media/senior_expo.fcf1f7d1.jpeg";